import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';
import '../styles/AboutTeamAndAppointmentSection.css';

const TeamAndAppointment = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        'service_400wfya',     // Replace with your EmailJS service ID
        'template_56bn4m9',    // Replace with your EmailJS template ID
        form.current,
        'v4aVMss4HfBL-_7FT'      // Replace with your EmailJS public key
      )
      .then(
        (result) => {
          console.log(result.text);
          alert('Appointment request sent successfully!');
          e.target.reset(); // Reset form after successful submission
        },
        (error) => {
          console.log(error.text);
          alert('Failed to send appointment. Please try again later.');
        }
      );
  };

  return (
    <div className="team-schedule-wrapper">
      <div className="team-section">
        <p className="section-subtitle">
          <span className="icon-lightning">⚡</span> TEAM
        </p>
        <h1 className="team-title">
          Trust Our Electrical Team<br />
          With All Of Your Service<br />
          Needs
        </h1>
        <p className="team-desc">
          Our team of seasoned electricians deliver exceptional service. With years
          of experience and honed skills, we tackle every project with expertise and
          efficiency, ensuring top-notch results for your electrical needs.
        </p>
        <div className="team-benefits">
          <div className="team-benefit">
            <span className="benefit-icon">🕑</span>
            <div>
              <div className="benefit-title">On Time Off Service</div>
            </div>
          </div>
          <div className="team-benefit">
            <span className="benefit-icon">📑</span>
            <div>
              <div className="benefit-title">Certification Profesional</div>
            </div>
          </div>
          <div className="team-benefit">
            <span className="benefit-icon">💡</span>
            <div>
              <div className="benefit-title">25 Years Experience</div>
            </div>
          </div>
        </div>
      </div>

      <div className="schedule-section">
        <p className="section-subtitle">
          <span className="icon-lightning">⚡</span> MAKE APPOINTMENT
        </p>
        <h1 className="section-title">Schedule A Service</h1>

        <form ref={form} onSubmit={sendEmail} className="schedule-form">
          <div className="form-row">
            <input type="text" placeholder="Name" name="user_name" className="form-input" required />
            <input type="email" placeholder="Email" name="user_email" className="form-input" required />
          </div>
          <div className="form-row">
            <input type="text" placeholder="Your Phone" name="user_phone" className="form-input" required />
            <input type="date" placeholder="Select Date" name="appointment_date" className="form-input" required />
          </div>
          <textarea placeholder="Message" name="message" className="form-textarea" required />
          <button type="submit" className="submit-btn">MAKE APPOINTMENT</button>
        </form>
      </div>
    </div>
  );
};

export default TeamAndAppointment;